import videomovie from '../assets/img/5884-video-movie.gif'
import imgpicture from '../assets/img/5856-image-picture.gif'
import videocont from '../assets/img/69-video-content-ta-dah.gif'
import loadingAnimation from '../assets/img/79609-loading-button.gif'
import loading_Animate from '../assets/img/81111-loading-13.gif'
import loading_App from '../assets/img/9419-loading-circles.gif'
export const columns = [
    {
        name: 'Autor',
        selector: row => <p style={{fontSize: '15px'}}>{row.autor}</p>
        ,
    },
    {
        name: 'Imagen',
        selector: row => <figure className='tb-progress'><img src={row.img} alt='imagen' /></figure>
        ,
    },
    {
        name: 'Descripción',
        selector: row => <p style={{fontSize: '15px'}}>{row.description}</p>
        ,
    },
    {
        name: 'Link',
        selector: row => row.link
        ,grow: 2
    },
]

export const collectionContribuciones = [
    {
        id: 1,
        autor: 'LottieFiles',
        description: 'Image / Picture',
        link: 'https://lottiefiles.com/5856-image-picture',
        img: imgpicture
    },
    {
        id: 2,
        autor: 'LottieFiles',
        description: 'Video content ta-dah!',
        link: 'https://lottiefiles.com/69-video-content-ta-dah',
        img: videocont
    },
    {
        id: 3,
        autor: 'LottieFiles',
        description: 'Video / Movie',
        link: 'https://lottiefiles.com/5884-video-movie',
        img: videomovie
    },
    {
        id: 4,
        autor: 'LottieFiles',
        description: 'Loading animation',
        link: 'https://lottiefiles.com/79609-loading-button',
        img: loadingAnimation
    },
    {
        id: 5,
        autor: 'LottieFiles',
        description: 'Loading #13',
        link: 'https://lottiefiles.com/81111-loading-13',
        img: loading_Animate
    },
    {
        id: 6,
        autor: 'LottieFiles',
        description: 'Loading circles ',
        link: 'https://lottiefiles.com/9629-loading',
        img: loading_App
    }
]
